import { Row, Col } from 'react-bootstrap';
import TimePicker from '../common/TimePicker';
import TextLoading from '@/app/common/components/skeleton/TextLoading';
import { breakpointsMediaQuery, useMediaQuery } from '@/helpers/utils';

const KeywordsTimePicker = ({ show, from_date, to_date }) => {
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);

  return (
    <Col lg="auto" className="mb-3 mb-md-0">
      <Row className="g-2 gy-md-0 h-100 align-items-center">
        <Col xs="auto">
          <h6 className="text-700 mb-0 text-nowrap">بازه زمانی</h6>
        </Col>
        <Col lg="auto">
          {show ? (
            <TimePicker initDay={from_date} lastDay={to_date} />
          ) : (
            <TextLoading
              width={isMdUp ? 205 : 100}
              height={24}
              isWidthPx={isMdUp}
            />
          )}
        </Col>
      </Row>
    </Col>
  );
};

export default KeywordsTimePicker;

{
  // const now = new DateObject({
  //   format: 'YYYY-MM-DD',
  //   calendar: gregorian,
  //   date: new Date()
  // }).subtract(3, 'days');
  // const lastMonth = new DateObject({
  //   format: 'YYYY-MM-DD',
  //   calendar: gregorian,
  //   date: new Date()
  // })
  //   .subtract(1, 'month')
  //   .subtract(3, 'days');
  // const lastSevenDays = new DateObject({
  //   format: 'YYYY-MM-DD',
  //   calendar: gregorian,
  //   date: new Date()
  // })
  //   .subtract(7, 'days')
  // .subtract(3, 'days');
  /* <div className="position-relative">
                    <OverlayTrigger
                      trigger="click"
                      rootClose
                      show={isTimeOpen}
                      placement="bottom-end"
                      overlay={
                        <Popover
                          id="popover-basic"
                          className="border border-300"
                          style={{ width: 550, maxWidth: '100%' }}
                        >
                          <Popover.Header
                            as="h3"
                            className="d-flex justify-content-between align-items-center"
                          >
                            تنظیم زمان{' '}
                          </Popover.Header>
                          <Popover.Body
                            style={{ height: 250 }}
                            className="px-3 py-2"
                          >
                            <Row className="h-100">
                              <Col xs={12} md={8}>
                                <h6 className="mt-3 ms-1">بازه زمانی</h6>
                                <TimePicker
                                  initDay={data?.data?.from_date}
                                  lastDay={data?.data?.to_date}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                className="border-1 overflow-y-scroll h-100 border-300 border-start"
                              >
                                <h6 className="mt-3"> انتخابگر تاریخ: </h6>
                                <Stack className="gap-1">
                                  <Button
                                    className="w-100"
                                    size="sm"
                                    variant="outline-secondary"
                                    onClick={() => {
                                      setSearchParams({
                                        start_date: lastSevenDays.format(),
                                        end_date: now.format()
                                      });
                                      setIsTimeOpen(false);
                                    }}
                                  >
                                    ۷ روز اخیر
                                  </Button>

                                  <Button
                                    className="w-100"
                                    size="sm"
                                    variant="outline-secondary"
                                    onClick={() => {
                                      setSearchParams({
                                        start_date: lastMonth.format(),
                                        end_date: now.format()
                                      });
                                      setIsTimeOpen(false);
                                    }}
                                  >
                                    ۳۰ روز اخیر
                                  </Button>
                                </Stack>
                                <h6 className="mt-3"> انتخابگر مقایسه:</h6>
                                <Stack className="gap-1">
                                  <Button
                                    className="w-100"
                                    size="sm"
                                    variant="outline-secondary"
                                    onClick={() => {
                                      setSearchParams({
                                        start_date: lastSevenDays.format(),
                                        end_date: now.format(),
                                        vs_start_date: lastSevenDays
                                          .subtract(7, 'days')
                                          .format(),
                                        vs_end_date: now
                                          .subtract(7, 'days')
                                          .format()
                                      });
                                      setIsTimeOpen(false);
                                    }}
                                  >
                                    مقایسه ۷ روز اخیر
                                  </Button>

                                  <Button
                                    className="w-100"
                                    size="sm"
                                    variant="outline-secondary"
                                    onClick={() => {
                                      setSearchParams({
                                        start_date: lastMonth.format(),
                                        end_date: now.format(),
                                        vs_start_date: lastMonth
                                          .subtract(30, 'days')
                                          .format(),
                                        vs_end_date: now
                                          .subtract(30, 'days')
                                          .format()
                                      });
                                      setIsTimeOpen(false);
                                    }}
                                  >
                                    مقایسه ۳۰ روز اخیر
                                  </Button>
                                </Stack>
                              </Col>
                            </Row>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <Button
                        onClick={() => {
                          setIsTimeOpen(!isTimeOpen);
                        }}
                        style={{ width: '30px', height: '30px' }}
                        title="تغییر زمان"
                        variant="outline-secondary"
                        size="sm"
                        className="d-flex align-items-center my-3 justify-content-center"
                      >
                        <FontAwesomeIcon icon="clock" className="fs--1" />
                      </Button>
                    </OverlayTrigger>
                  </div> */
}
